import React from 'react'
import './CSS/ShopCategory.css'
import { ShopContext } from '../Components/Context/ShopContext';
import { useContext } from 'react';
import dropdown_icon from '../Components/Assets/dropdown_icon.png';
import Item from '../Components/Item/item';

const ShopCategory = (props) => {
  const {all_product} = useContext(ShopContext);
  return (
    <div className='shop-category'>
      <img src={props.banner} alt="" className='shopcategory-banner'/>
      <div className="shopcategory-indexSort">
        <p>
          <span>Showing 1-12</span> out of 36 products
        </p>
        <div className="shopcategory-sort">
          Sort by <img src={dropdown_icon} alt="" />
        </div>
      </div>
      <div className="shopcategory-products">
        {all_product.map((item,i)=>{
           if (props.category===item.category) {
             return <Item key={i} id={item.id} name={item.name} image={item.image} new_price={item.new_price} old_price={item.old_price} />
           }
           else {
            return null;
           }
        })}
      </div>
      <div className="shopcategory-loadmore">
        <a href="https://github.com/Aryankpoor/secondhand/blob/master/instructions.md" target="_blank" alt="">Explore more</a>
        
      </div>
    </div>
  )
}

export default ShopCategory
